import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setPatientBillingStatistics } from 'src/store/modules/patient/dashboard'

import { PATIENT_BILLING_STATISTICS } from 'src/constants'

export const getPatientBillingStatistics = (uuid) => async (dispatch) => {
  try {
    const res = await httpClient.request({
      method: 'get',
      url: {
        pathname: PATIENT_BILLING_STATISTICS,
        params: { uuid }
      }
    })

    dispatch(setPatientBillingStatistics(res))
  } catch (err) {
    catchError(err)
  }
}
